import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const posts = [
  {
    slug: 'intro',
    title: 'an introduction',
    date: '2026-07-27',
    perms: '-rw-r--r--',
    body: [
      "im pretty new to this blog thing but found that writing my thoughts helps me organize and remember them much better. ill just start off with an introduction: im vansh, 19 yo, computer science and engineering student at uc irvine. rest of my website talks about my experiences.",
      "i got really into startups around a year and a half ago, a friend introduced me. i ended up working with him on a few startups the past 1.5 years, got backed by founders inc., saw money enter my bank account for the first time, and grew my network a lot within sf. the startup community at uc irvine is pretty dead so going to sf this summer definitely has helped me grow a lot. i have also never grinded harder than this ever before (except maybe when i was studying for olympiads in high school).",
      "so i spent the last 1.5 years doing ai agents, building automation tools, going into marketing, learning how to speak (this has definitely improved my speaking abilities a lot), and just learning a lot more about ai. but most of my experiences before this was in robotics. my research right now is also in robotics.",
      "a few things about startups that ive learned. startups are losing value now. everyone is just spamming startups and making some empty ai startup that does nothing. the meaning of startups and creating a business has lost value. its not about building something cool and new and remarkable, something that actually helps society, something that someone can be identified with. we used to have new ideas like doordash or polymarket, these genuinely new and interesting things. now its just a bunch of thin ai wrappers or some internal tool powered by claude. like sure architecture is important — its proven by claude code (the model is good, but claude code's architecture is what makes it so good). but it gets to a point. llms are getting better. building some over-engineered architecture that no one needs isnt going to solve anything. so thats a reason i might be stepping away from startups at the moment.",
      "and now about the robotics stuff. id say im pretty ahead at the moment compared to a lot of college students because of my past experiences, but i tried to build a robotics startup and realized who my competition is. getting funding wouldn't be too hard since investors just want to fund robotics startups at the moment because its the next wave, but my competition is phds with 10+ years of experience. and instead of building some dev tools for robotics (which is cool btw no hate to whoevers doing that), i enjoy building. so my plan is to just focus on research and robotics industrial experience, and see where i go from there.",
      "just a few days ago, i broke up with my cofounder. this is the startup i was working on that got backed by founders inc. and all that. he got pretty hard to work with. realized that my luck with working with people hasn't been that good. every time i work with someone, they dont end up working and i get stuck doing all the work or nothing gets done. still waiting to come across the right person, but i have a lot of time for that anyways.",
      "another thought ive had is linkedin. there are so many posts that exist just for the sake of posting — people dressing up a mundane non-event as some big life lesson, chasing an audience with nothing actually behind it. it gets kind of annoying. the platform is meant for real work and real connections, not performing for engagement. its not building a community or motivating anyone — its just posting to post.",
      "thats all i have for today. ill probably be pretty inconsistent with writing my thoughts but thats the purpose of this anyways: just a place to write my thoughts whenever they come up.",
    ],
  },
];

export default function Blog() {
  const [expanded, setExpanded] = useState(null);

  const handleClick = (slug) => {
    setExpanded(expanded === slug ? null : slug);
  };

  return (
    <div>
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~/blog</span>
        <span className="p-char">$</span>
        <span className="p-cmd">ls -la</span>
      </div>

      <div className="output">
        <div className="total-line">total {posts.length}</div>
        {posts.map((post, i) => (
          <motion.div
            key={post.slug}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04, duration: 0.2 }}
          >
            <div
              className="file-row"
              role="button"
              tabIndex={0}
              aria-expanded={expanded === post.slug}
              onClick={() => handleClick(post.slug)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleClick(post.slug);
                }
              }}
            >
              <span className="f-perms">{post.perms}</span>
              <span className="f-size">--</span>
              <span className="f-date">{post.date}</span>
              <span className="f-name">{post.title}</span>
            </div>

            <AnimatePresence>
              {expanded === post.slug && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.2 }}
                  style={{ overflow: 'hidden' }}
                >
                  <div className="prompt" style={{ marginTop: 16, marginBottom: 4 }}>
                    <span className="p-user">vansh</span>
                    <span className="p-sep">@</span>
                    <span className="p-user">portfolio</span>
                    <span className="p-sep">:</span>
                    <span className="p-path">~/blog</span>
                    <span className="p-char">$</span>
                    <span className="p-cmd">cat {post.date}-{post.slug}.md</span>
                  </div>

                  <div className="content-body">
                    {post.body.map((para, idx) => (
                      <p key={idx}>{para}</p>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
